































































import EventBus from '@/eventBus';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import axios from 'axios';

// FunnelEvent records key actions that lead a user into an upsell/upgrade funnel.
//
//	{
//	  "funnel": "curtain",           // identifies the flow (paywall, promo, etc.)
//	  "step": "feature_click",       // allowed: feature_click | modal_shown | cta_click
//	  "feature_key": "curtain_toggle",
//	  "location": "dashboard/projects-list",
//	  "full_path": "/projects?tab=overview",
//	  "parameters": {
//	    "trigger_id": "project-card-42"
//	  }
//	}
export default {
    name: 'CoPaywall',
    components: {
        CoModal,
        CoHeadline,
        CoText,
        CoIcon,
        CoButton,
    },
    props: {
        feature: {
            type: String,
            required: false,
            validator(value: string) {
                const allowedFeatures = [
                    'none',
                    'permissions',
                    'more-channels',
                    'more_channels',
                    'more-members',
                    'more-admins',
                    'pin-post',
                    'pin_post',
                    'announce-post',
                    'announce_post',
                    'announcement',
                    'custom-fields',
                    'custom_fields',
                    'branded-domain',
                    'customization',
                    'white-label',
                    'bigger-files',
                    'more-storage',
                ];
                return allowedFeatures.includes(value);
            },
            default: 'none',
        },
        plan: {
            type: String,
            required: false,
            default: 'unknown',
        },
    },
    data() {
        return {
            manageUrl: null as string | null,
        };
    },
    computed: {
        effectivePlan() {
            const propPlan = (this.plan || '').toLowerCase();
            const storePlan = (
                this.$store?.state?.space?.PlanSlug ||
                this.$store?.state?.space_configuration_admin?.PlanSlug ||
                ''
            ).toLowerCase();
            return propPlan && propPlan !== 'unknown' ? propPlan : storePlan || 'unknown';
        },
        billingAdminId() {
            return (
                this.$store?.state?.space_configuration_admin?.PaymentMethodeCreatedBy ||
                this.$store?.state?.space?.PaymentMethodeCreatedBy ||
                null
            );
        },
        isBillingAdmin() {
            return Boolean(this.$store?.state?.me?.ID && this.$store.state.me.ID === this.billingAdminId);
        },
        isBusinessPlan() {
            return this.effectivePlan === 'business';
        },
        ctaLabel() {
            return this.isBusinessPlan ? this.$t('paywall.cta2') : this.$t('paywall.cta');
        },
        normalizedFeature() {
            return (this.feature || 'none').toLowerCase().replace(/_/g, '-');
        },
        paywallContent() {
            const featureKey = this.normalizedFeature;
            const planKey = this.effectivePlan;
            const locale = this.$i18n?.locale || 'en';
            const baseLocale = locale.split('-')[0];
            const messages = this.$i18n?.messages || {};
            const paywallCopy =
                messages[locale]?.paywall?.featureCopy ||
                messages[baseLocale]?.paywall?.featureCopy ||
                messages.en?.paywall?.featureCopy ||
                {};
            const featureCopy = paywallCopy[featureKey] || paywallCopy.default || {};
            const planCopy = featureCopy[planKey] || featureCopy.unknown || paywallCopy.default?.unknown || {};
            return {
                headline: planCopy.headline || '',
                subline: planCopy.subline || '',
                bullets: Array.isArray(planCopy.bullets) ? planCopy.bullets : [],
            };
        },
    },
    mounted() {
        // this.$refs.paywallmodal.show();
    },

    methods: {
        // fetchCustomerPortalUrl lazily loads the Stripe customer portal URL for billing admins only.
        fetchCustomerPortalUrl() {
            if (!this.isBillingAdmin || this.manageUrl) {
                return Promise.resolve(this.manageUrl);
            }

            return axios
                .get('/admin/space/billing/customer-portal-url')
                .then((response) => {
                    this.manageUrl = response?.data?.URL || null;
                    return this.manageUrl;
                })
                .catch((error) => {
                    const msg = {
                        Message: this.$t('messages.customerPortalUrlFailed'),
                        Details: '',
                    };
                    EventBus.$emit('ERROR', msg);
                    throw error;
                });
        },

        // openSupportContactWindow keeps the enterprise/business CTA inside the existing support flow.
        openSupportContactWindow() {
            this.$intercom.showNewMessage('Hi coapp Sales Team ...');
            this.$refs.paywallmodal.hide();
        },

        // openAccountPage preserves the current fallback for non-billing-admin users and failed portal lookups.
        openAccountPage() {
            this.$router.push('/admin/account');
            this.$refs.paywallmodal.hide();
        },

        // recordPaywallUpgradeClick logs when a user clicks on the upgrade call-to-action
        recordPaywallUpgradeClick() {
            const route = this.$route || null;
            const location = route?.path || window.location.pathname;
            const fullPath = route?.fullPath || `${window.location.pathname}${window.location.search}`;

            // record event in Intercom for feature usage tracking and targeted messaging
            EventBus.$emit('intercomTrackEvent', {
                eventName: `paywall_cta_click`,
                payload: {
                    feature: this.feature,
                },
            });
            // also record a specific event for the triggered feature to allow granular analysis and targeting
            EventBus.$emit('intercomTrackEvent', {
                eventName: `paywall_cta_click_${this.feature}`,
            });

            axios
                .post('/me/activity/funnel', {
                    funnel: 'paywall',
                    step: 'cta_click',
                    feature_key: this.feature,
                    location,
                    full_path: fullPath,
                    parameters: {
                        plan: this.effectivePlan,
                    },
                })
                .then(() => {
                    // timeout to ensure activity is recorded before navigation
                    setTimeout(() => {
                        if (this.isBusinessPlan) {
                            this.openSupportContactWindow();
                            return;
                        }

                        if (!this.isBillingAdmin) {
                            this.openAccountPage();
                            return;
                        }

                        this.fetchCustomerPortalUrl()
                            .then((url) => {
                                if (url) {
                                    window.open(url).focus();
                                    this.$refs.paywallmodal.hide();
                                    return;
                                }

                                this.openAccountPage();
                            })
                            .catch(() => {
                                this.openAccountPage();
                            });
                    }, 200);
                })
                .catch((error) => {
                    console.error('Failed to record upgrade click activity', error);
                    if (this.isBusinessPlan) {
                        this.openSupportContactWindow();
                        return;
                    }

                    if (!this.isBillingAdmin) {
                        this.openAccountPage();
                        return;
                    }

                    this.fetchCustomerPortalUrl()
                        .then((url) => {
                            if (url) {
                                window.open(url).focus();
                                this.$refs.paywallmodal.hide();
                                return;
                            }

                            this.openAccountPage();
                        })
                        .catch(() => {
                            this.openAccountPage();
                        });
                });
        },

        // recordPaywallTrigger logs when a user triggers the paywall by clicking on a
        recordPaywallTrigger() {
            const route = this.$route || null;
            const location = route?.path || window.location.pathname;
            const fullPath = route?.fullPath || `${window.location.pathname}${window.location.search}`;

            // record event in Intercom for feature usage tracking and targeted messaging
            EventBus.$emit('intercomTrackEvent', {
                eventName: `paywall_triggered`,
                payload: {
                    feature: this.feature,
                },
            });
            // also record a specific event for the triggered feature to allow granular analysis and targeting
            EventBus.$emit('intercomTrackEvent', {
                eventName: `paywall_triggered_${this.feature}`,
            });

            axios
                .post('/me/activity/funnel', {
                    funnel: 'paywall',
                    step: 'feature_click',
                    feature_key: this.feature,
                    location,
                    full_path: fullPath,
                    parameters: {
                        plan: this.effectivePlan,
                    },
                })
                .catch((error) => {
                    console.error('Failed to record paywall trigger activity', error);
                });
        },
        handleCtaClick() {
            this.recordPaywallUpgradeClick();
        },
        show() {
            this.$refs.paywallmodal.show();
            this.recordPaywallTrigger();
        },
    },
};
